import { Particle } from "../particle";
import { colorGradient, hold, lerp, parabolic, randomBetween } from "../interpolation";

const GRAVITY = 20;

export class LargeGroundExplosionParticle extends Particle {
	constructor(originX: number, originY: number) {
		const vx = randomBetween(-6, 6); // horizontal scatter
		const vy = -randomBetween(3, 9); // upward launch; apex ~2 cells under GRAVITY, then arcs down

		super(originX, originY, {
			ttl: randomBetween(450, 750),
			size: lerp(0.5, 0.1),
			opacity: hold(1.0, 0.5, lerp(1.0, 0.0)),
			color: colorGradient([
				{ r: 255, g: 220, b: 50 },
				{ r: 255, g: 120, b: 20 },
				{ r: 80, g: 80, b: 80 },
			]),
			rotation: lerp(0, randomBetween(-2, 2)),
			position: parabolic(vx, vy, GRAVITY),
		});
	}
}
